import { BasePreAuthenticationConfig } from '@/services/auth/call-with-auth/base'
import { none, Option, some } from 'fp-ts/lib/Option'

interface AutoLoadParameter {
  readonly userKey: string
  readonly hash: string
  readonly site: string
}

export class PreAutoLogin extends BasePreAuthenticationConfig {
  readonly id: string = 'auto login'

  process(): Promise<void> {
    return this.autoLoadParameter.foldL(
      () => Promise.reject(
        new Error('auto login parameter not fulfilled')
      ),
      ({ userKey, hash, site }) => this.authGateway.autoLogin(userKey, hash, site)
        .then(r => r.fold(
          this.throwOnFail('fail auto login'),
          this.onSuccess('success auto login')
        ))
    )
  }

  cascade(): boolean {
    return true
  }

  processable(): boolean {
    return this.autoLoadParameter.isSome()
  }

  private get autoLoadParameter(): Option<AutoLoadParameter> {
    const accessedURL = this.authStateStore.accessedURL()
    const query = accessedURL.searchParams

    const userKey = query.get('o')
    const hash = query.get('hash')
    const site = this.pageContext.brandEnglishName

    return userKey && hash && site
           ? some({ userKey, hash, site })
           : none
  }
}

/**
 * 自動ログインに失敗した場合に後続の認証を試行せずエラーとする
 */
export class PreAutoLoginNoCascade extends PreAutoLogin {
  readonly id: string = 'auto login no cascade'

  /** override */
  cascade(): boolean {
    return false
  }
}
